// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from '@/router';
import store from '@/store';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueLodash from 'vue-lodash';
import Geocoder from '@pderas/vue2-geocoder';
import VueGeolocation from 'vue-browser-geolocation';
import VueStripeCheckout from 'vue-stripe-checkout';
import config from './config';

Vue.use(VueStripeCheckout, config.stripePublicKey());

Vue.component('datetime', Datetime);

Vue.config.productionTip = false;

Vue.use(VueGeolocation);

Vue.use(BootstrapVue);
Vue.use(VueLodash);
Vue.use(Geocoder, {
  googleMapsApiKey: config.googleApiKey()
});

Vue.use(VueGoogleMaps, {
  load: {
    key: config.googleApiKey(),
    libraries: 'places' // necessary for places input
  }
});

Vue.config.silent = true;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});
// router.replace('/')
